export const REWARD_BOX_WITHDRAW_MAX_LIMIT = 12

export const REWARD_BOX_PROCESSING_TIME = 180 // seconds

export const REWARD_BOX_PROCESS_STATUS = {
  INIT: 0,
  DEPOSITING: 1,
  DEPOSITED: 2,
  REFUNDING: 3
}

export const DEFAULT_ETH_PRICE = 2652

export const WALLET_ACCOUNT_STATUS = {
  CONNECTED: 'connected'
}
